import evaluations from '@/service/evaluations';
import createStore from '@/store/base/create-store';

const { state, actions, mutations } = createStore(evaluations);
const modules = {};
const getters = {};
const tempState = {
    // 页面配置
    pageOption: {
        user_id: '',
        order_id: '',
    },
    ...state
}
const tempMutations = {
    setPageOption(state, data) {
        state.pageOption = _.merge(state.pageOption, data);
    },
    ...mutations
}
const tempActions = {
    /**
     * 页面配置初始化 pageOption
     */
    pageOptionInit({ dispatch, commit, state }, param) {
        const { host, unique_key, uniqueKey, id } = param;
        if (unique_key || uniqueKey || id) {
            return dispatch(
                'vomDecode',
                {
                    key: unique_key || uniqueKey || id,
                    host
                },
                { root: true }
            ).then(res => {
                // 解密统一参数
                if (res.result_code === 'success') {
                    commit('setPageOption', JSON.parse(res.data.value));
                }
                return state.pageOption;
            });
        }
    },
    ...actions
}
const store = {
    namespaced: true,
    strict: true,
    getters,
    modules,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations
}
export default store;



// WEBPACK FOOTER //
// ./src/store/evaluations.js